import FeatureSnippetSpells from "./FeatureSnippetSpells";

export default FeatureSnippetSpells;
export { FeatureSnippetSpells };
